import React from "react";
import bg1 from "../../../Images/cryptocurrency.png"
import { Link } from "react-router-dom"
import "./Home.css";

const Home = () => {

    return (

        <div className="landing-page">
            <div className="info">
                <h1>Receive Real-Time Alerts <br/>& Take Advantage of Derivates Variations.</h1>
                <h5>Time Laps: 10, 20, 30 Seconds and more...</h5>
                <div className="main-btns">
                    <Link to="/demo"><button className="home-btn">Try It Free !</button></Link>
                    <Link to="/about"><button className="home-btn-sec">Know More</button></Link>
                </div>
            </div>
            <div className="image">
                <img alt="background" src={bg1} />
            </div>
        </div>
    );
};
export default Home;
